export default __webpack_public_path__ + "static/media/detail_image.1bd62974.svg";